import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-drs-deny',
  templateUrl: './drs-deny.component.html',
  styleUrl: './drs-deny.component.scss',
  standalone: false
})
export class DrsDenyComponent implements OnInit {

  onCloseLinkSubmit: () => void;
  correlationId: string;

  constructor(private readonly translate: TranslateService){}
  
  ngOnInit(): void {

  }

  onCloseClick(){
      this.onCloseLinkSubmit();
  }

  OnCopyReference() {
    const copyText = this.correlationId || '';

    if (document.hasFocus() && navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(copyText)
        .catch(() => {
          this.fallbackCopyToClipboard(copyText);
        });
      return;
    }

    this.fallbackCopyToClipboard(copyText);
  }

  private fallbackCopyToClipboard(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

}
